const initialState = {
    current: {}
}

const users = (state = initialState, action) => {
    switch (action.type) {
        case '/users/login':
            return {...state, current: action.payload}
        
        default:
            return state
    }
}

export default users